<template>
    <div>
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 class="h2">Administration</h1>
        </div>

        <div class="mb-3 background-alt">
            <div>
                <a title="Ajouter un utilisateur" class="btn btn-custom float-right col-lg-2 text-white mb-3"
                   @click="openModal()">Ajouter</a>
            </div>

            <div class="table-responsive">
                <vuetable ref="vuetable"
                          api-url="/api/users"
                          :fields="fields"
                          pagination-path=""
                          :http-options="{ headers: { 'Authorization': 'Bearer ' + api_token }}"
                          @vuetable:pagination-data="onPaginationData"
                          class="table"
                          no-data-template=""
                >

                    <div slot="gender-slot" slot-scope="props">
                        <button class="btn-custom btn" title="Editer l'utilisateur" @click="openModal(props.rowData)">
                            <i class="fas fa-pencil-alt"></i></button>
                        <button class="btn-danger btn" title="Supprimer l'utilisateur"
                                @click="deleteUser(props.rowData.id)"><i class="fas fa-trash-alt"></i></button>
                    </div>
                </vuetable>
            </div>

            <div class="row col-lg-12 pr-0">
                <div class="mr-auto">
                    <vuetable-pagination-info ref="paginationInfo"
                                              class="alert alert-info tablePagination"
                                              info-template="Affichage de {from} à {to} sur {total} utilisateurs"
                                              no-data-template="Aucun utilisateur"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                                         @vuetable-pagination:change-page="onChangePage"
                                         :css="css.pagination"
                    ></vuetable-pagination>
                </div>
            </div>
        </div>

        <modal :showModal="showModal" :hideModal="hideModal" :openModal="openModal">
            <h5 slot="header">
                Edition d'un utilisateur
            </h5>

            <span slot="body" class="w-100">
                <div class="row">
                    <div class="col-lg-6">
                        <label>Prénom :</label>
                        <span class="msgRed">{{ errors.first('firstName') }}</span>
                        <input type="text" class="form-control" name="firstName" placeholder="Prénom..."
                               v-validate="{required: true}" v-model="firstName"/>
                    </div>
                    <div class="col-lg-6">
                        <label>Nom :</label>
                        <span class="msgRed">{{ errors.first('lastName') }}</span>
                        <input type="text" class="form-control" name="lastName" placeholder="Nom..."
                               v-validate="{required: true}" v-model="lastName"/>
                    </div>
                </div>

                <label>E-mail : </label>
                <span class="msgRed">{{ errors.first('email') }}</span>
                <input type="email" class="form-control" name="email" placeholder="E-mail..."
                       v-validate="{required: true, email:true}" v-model="email"/>

                <div v-if="edit === false">
                    <label>Mot de passe : </label>
                    <span class="msgRed">{{ errors.first('password') }}</span><span class="msgRed"
                                                                                    v-if="pwd !== confirmPwd">{{ 'Les mots de passe ne correspondent pas.' }}</span>
                    <input type="password" class="form-control" name="password" v-validate="{required: true}"
                           v-model="pwd"/>

                    <label>Confirmation mot de passe : </label>
                    <input type="password" class="form-control" name="confPwd" v-model="confirmPwd"/>
                </div>

                <label>Rôle : </label>
                <span class="msgRed" v-if="empty === true">Veuillez sélectionner un rôle.</span>

                <div class="d-flex">

                    <div v-if="!admRoleDisabled" class="form-check">
                        <input id="admPu" class="form-check-input" type="radio" name="role" value="1" v-model="role" />
                        <label class="form-check-label" for="admPu">Administrateur PU</label>
                    </div>

                    <div class="form-check">
                        <input id="adm" type="radio" name="role" value="2" v-model="role"/>
                        <label for="adm">Administateur</label>
                    </div>

                    <div class="form-check">
                        <input id="user" type="radio" name="role" value="3" v-model="role"/>
                        <label for="user">Utilisateur</label>
                    </div>

                    <div class="form-check">
                        <input id="support" type="radio" name="role" value="4" v-model="role"/>
                        <label for="support">Support</label>
                    </div>

                </div>

            </span>

            <span slot="footer">
                <button class="btn btn-success" @click="editUser">Valider </button>
                <button class="btn btn-danger" @click="hideModal">Fermer </button>
            </span>
        </modal>

        <infringement-search-result-modal></infringement-search-result-modal>

    </div>
</template>

<script>

    import Swal from 'sweetalert2';
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    import Vuetable from 'vuetable-2';
    import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
    import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo';
    import Modal from './layout/Modal';
    import {Validator} from 'vee-validate';
    import InfringementSearchResultModal from "./layout/InfringementSearchResultModal";

    Vue.use(VeeValidate, {fieldsBagName: 'formFields'});

    export default {
        components: {Vuetable, VuetablePagination, VuetablePaginationInfo, Modal, InfringementSearchResultModal},
        computed: {
            api_token() {
                return api_token;
            }
        },
        data() {
            return {
                firstName: '',
                lastName: '',
                email: '',
                pwd: '',
                confirmPwd: '',
                role: '',
                empty: false,
                url: '',
                showModal: false,
                edit: false,
                userId: '',
                admRoleDisabled: false,

                fields: [
                    {
                        name: 'last_name',
                        title: 'Nom'
                    },
                    {
                        name: 'first_name',
                        title: 'Prénom'
                    },
                    {
                        name: 'email',
                        title: 'E-mail'
                    },
                    {
                        name: 'role.name',
                        title: 'Rôle'
                    },
                    {
                        name: 'gender-slot',
                        title: '',
                    },
                ],

                css: {
                    pagination: {
                        activeClass: 'btn-custom',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: '',
                            prev: '',
                            next: '',
                            last: '',
                        }
                    }
                },
            }
        },
        created() {
            axios.get('/api/getAuthenticatedUserRole')
                .then(result => {
                    this.admRoleDisabled = result.data != 1 ? true : false;
                });
        },
        methods: {
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData);
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },

            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },

            createRules() {
                //Change alert messages
                const dictionnary = {
                    en: {
                        messages: {
                            required: () => 'Champs requis.',
                            email: () => 'Adresse email non valide.',
                            min: () => 'Taille minimum de 6.'
                        }
                    }
                };
                Validator.localize(dictionnary);
            },

            editUser() {
                //Verify is the mail is already existing
                this.checkMail().then((mailExist) => {
                    if (mailExist === false) {
                        //In case of add
                        if (this.edit === false) {
                            if (this.role === '') {
                                this.empty = true;
                            } else {
                                this.addUser();
                            }
                        } else {
                            //In case of edition
                            this.updateUser();
                        }

                        if (this.empty !== true) {
                            this.$refs.vuetable.reload();
                            this.hideModal();
                        }
                    } else {
                        Swal(
                            'E-mail déjà utilisé.',
                        );
                    }
                });
            },

            checkMail() {
                this.empty = false;

                return axios.post('/api/checkMail', {
                    email: this.email,
                    edit: this.edit,
                    userId: this.userId
                })
                    .then(result => {
                        return result.data;
                    })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            addUser() {
                axios.post('/api/users', {
                    firstName: this.firstName,
                    lastName: this.lastName,
                    role: this.role,
                    email: this.email,
                    password: this.pwd
                })
                    .then(result => {
                        Swal(
                            'Utilisateur ajouté.',
                        );
                    })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            updateUser() {
                axios.put('/api/users/' + this.userId, {
                    firstName: this.firstName,
                    lastName: this.lastName,
                    role: this.role,
                    email: this.email
                })
                    .then(result => {
                        Swal(
                            'Utilisateur modifié.',
                        );
                    })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            openModal(data) {
                if (data !== undefined) {
                    this.firstName = data.first_name;
                    this.lastName = data.last_name;
                    this.email = data.email;
                    this.role = data.role_id;
                    this.userId = data.id;
                    this.edit = true;
                } else {
                    this.edit = false;
                }
                this.showModal = true;
            },

            hideModal() {
                this.firstName = '';
                this.lastName = '';
                this.role = '';
                this.email = '';
                this.pwd = '';
                this.confirmPwd = '';
                this.empty = false;
                this.$validator.reset();

                this.showModal = false;
            },

            deleteUser(id) {
                Swal({
                    title: 'Êtes vous sur ?',
                    text: "Vous ne pourrez pas revenir en arrière.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Annuler',
                    confirmButtonText: 'Supprimer'
                }).then((result) => {
                    axios.delete('/api/users/' + id)
                        .then(result => {
                            Swal(
                                'Supprimé !',
                                'Utilisateur supprimé.',
                                'success'
                            );
                        });
                    this.$refs.vuetable.reload();
                });
            }
        },
        mounted() {
            this.createRules();
        }
    }
</script>

<style scoped>
    .msgRed {
        color: red;
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/Administration.vue